<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <b-alert
      :show="messageObject.warning.count"
      variant="danger"
      dismissible
      @dismissed="messageObject.warning.count = 0"
      @dismiss-count-down="warningCountChanged"
      >{{ messageObject.warning.content }}
    </b-alert>
    <h2>帳號管理</h2>
    <b-row align-h="between" class="mb-4">
      <b-col md="auto">
        <b-button @click="addaccount" variant="primary">新增帳號</b-button>
      </b-col>
      <b-col md="auto">
        <b-form inline>
          <b-input-group-prepend is-text>
            查詢
          </b-input-group-prepend>
          <!-- <label
                        class="sr-only"
                        for="inline-form-input-name"
                    >關鍵字</label> -->
          <b-form-input
            id="inline-form-input-name"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="filterSearch"
            type="search"
            placeholder="關鍵字"
          >
          </b-form-input>
          <!-- <b-button variant="primary">查詢</b-button> -->
        </b-form>
      </b-col>
    </b-row>
    <b-table
      id="my-table"
      bordered
      striped
      outlined
      hover
      :items="accountlist.mappingitems"
      :fields="
        window.width < 700
          ? accountlist.fields_mobile
          : window.width < 800
          ? accountlist.fields_laptop
          : accountlist.fields
      "
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filterSearch"
      @filtered="onFiltered"
    >
      <template v-slot:cell(edit)="data">
        <b-button-group v-if="hideAccount(data.item)">
          <b-button
            v-show="window.width < 800"
            style="margin-right: 0.3rem;"
            variant="success"
            @click="data.toggleDetails"
            >{{ data.detailsShowing ? "隱藏" : "詳細" }}</b-button
          >
          <b-button
            style="margin-right: 0.3rem;"
            variant="success"
            @click="editaccount(data.item)"
            >編輯</b-button
          >
          <b-button variant="danger" @click="deleteaccount(data.item)"
            >刪除</b-button
          >
        </b-button-group>
      </template>
      <!-- <template #cell(AC_GROUP_ID)="data">
                {{ groupName(data.value) }}
            </template>
                <template #cell(AC_STATUS)="data">
                {{ statusName(data.value) }}
            </template> -->
      <template #row-details="row">
        <b-card>
          <template v-if="window.width < 700">
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>單位:</b></b-col>
              <b-col>{{ row.item.AC_CONTENT }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>職稱:</b></b-col>
              <b-col>{{ row.item.AC_TITLE }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Email帳號:</b></b-col>
              <b-col>{{ row.item.AC_USERID }}</b-col>
            </b-row>
          </template>
          <b-row class="mb-2">
            <b-col sm="3" class="text-sm-right"><b>電話:</b></b-col>
            <b-col>{{ row.item.AC_TEL }}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col sm="3" class="text-sm-right"><b>群組:</b></b-col>
            <b-col>{{ row.item.AC_GROUP_ID }}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col sm="3" class="text-sm-right"><b>狀態:</b></b-col>
            <b-col>{{ row.item.AC_STATUS }}</b-col>
          </b-row>
          <b-button variant="success" @click="row.toggleDetails">隱藏</b-button>
        </b-card>
      </template>
    </b-table>
    <b-pagination
      v-show="totalRows > perPage"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="my-table"
      align="right"
    ></b-pagination>
    <b-modal
      id="modal-1"
      ref="accountinfomodal"
      size="lg"
      :title="addAccount ? '新增帳號' : '帳號設定'"
      ok-title="確定變更"
      cancel-title="取消"
      @ok="handleAddAccountOk"
    >
      <b-form-group label="E-mail 帳號：">
        <b-form-input
          v-model="accountlist.newaccount.AC_USERID"
          type="text"
          :disabled="!addAccount"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="姓名：">
        <b-form-input
          v-model="accountlist.newaccount.AC_USERNAME"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="單位：">
        <b-form-input
          v-model="accountlist.newaccount.AC_CONTENT"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="職稱：">
        <b-form-input
          v-model="accountlist.newaccount.AC_TITLE"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="電話：">
        <b-form-input
          v-model="accountlist.newaccount.AC_TEL"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="群組：">
        <b-form-select
          v-model="accountlist.newaccount.AC_GROUP_ID"
          :options="parseToOptions(grouplist)"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group label="狀態：">
        <b-form-radio-group
          :options="parseToOptions(statuslist)"
          v-model="accountlist.newaccount.AC_STATUS"
        >
        </b-form-radio-group>
      </b-form-group>
      <b-form-group>
        <span
          v-b-modal.modal-forgetpassword
          class="text-info"
          v-if="!addAccount"
          >重寄設定密碼連結</span
        >
        <b-modal
          id="modal-forgetpassword"
          ref="forgetpasswordmodal"
          title="重寄設定密碼連結"
          @ok="handleReSentEmailOk"
        >
          是否重新寄送密碼連結
        </b-modal>
      </b-form-group>
    </b-modal>
    <b-modal
      id="modal-deleteaccount"
      ref="deleteaccountmodal"
      title="刪除區段"
      @ok="handleAccountDelete"
    >
      是否刪除此帳號
    </b-modal>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      totalRows: 1,
      filterSearch: null,
      perPage: 8,
      currentPage: 1,
      selected: "all",
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#",
        },
        {
          text: "帳號權限管理",
          active: true,
        },
        {
          text: "帳號管理",
          active: true,
        },
      ],
      hidelist: ["joechen@gis.fcu.edu.tw", "joel@gis.tw"],
      messageObject: {
        warning: {
          //show: false,
          content: null,
          count: 0,
        },
        success: {
          //show: false,
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      account: [],
      statuslist: ["未開通", "啟用 ", "停用"],
      window: {
        width: 0,
        height: 0,
      },
      grouplist: [],
      accountlist: {
        fields: [
          {
            key: "AC_USERNAME",
            label: "姓名",
          },
          {
            key: "AC_CONTENT",
            label: "單位",
          },
          {
            key: "AC_TITLE",
            label: "職稱",
          },
          {
            key: "AC_USERID",
            label: "Email帳號",
          },
          {
            key: "AC_TEL",
            label: "電話",
          },
          {
            key: "AC_GROUP_ID",
            label: "群組",
          },
          {
            key: "AC_STATUS",
            label: "狀態",
          },
          {
            key: "edit",
            label: "編輯",
          },
        ],
        fields_laptop: [
          {
            key: "AC_USERNAME",
            label: "姓名",
          },
          {
            key: "AC_CONTENT",
            label: "單位",
          },
          {
            key: "AC_TITLE",
            label: "職稱",
          },
          {
            key: "AC_USERID",
            label: "Email帳號",
          },
          {
            key: "edit",
            label: "編輯",
          },
        ],
        fields_mobile: [
          {
            key: "AC_USERNAME",
            label: "姓名",
          },
          {
            key: "edit",
            label: "編輯",
          },
        ],
        items: [],
        newaccount: {
          AC_USERNAME: null,
          AC_CONTENT: null,
          AC_TITLE: null,
          AC_USERID: null,
          AC_TEL: null,
          AC_GROUP_ID: null,
          AC_STATUS: null,
          AC_ID: null,
        },
        mappingitems: [],
      },
      addAccount: true,
      apiAccountGetList: (data) =>
        this.userRequest.post("/API/Default/AccountGetList", data),
      apiAccountGroupGetList: (data) =>
        this.userRequest.post("/API/Default/AccountGroupGetList", data),
      apiUpdateAccountAdmin: (data) =>
        this.userRequest.post("/API/Default/UpdateAccountAdmin", data),
      apiInsertAccountAdmin: (data) =>
        this.userRequest.post("/API/Default/InsertAccountAdmin", data),
      apiDeleteAccountAdmin: (data) =>
        this.userRequest.post("/API/Default/DeleteAccountAdmin", data),
      apiForgetPassword: (data) =>
        this.userRequest.post("API/Default/LastPass", data),
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.checkLogin();
    // this.checkPermission()
    //this.FunctionToken(this.getAccountList, {});
  },
  computed: {
    rows() {
      return this.accountlist.items.length;
    },
  },
  methods: {
    //Summary//
    //API methods//
    //Summary//
    //Start//
    setForgetPasswordEmail(data) {
      this.apiForgetPassword(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-forgetpassword");
              alert("已傳送驗證信到該信箱");
            });
          } else {
            this.$bvModal.hide("modal-forgetpassword");
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getAccountList(data) {
      this.apiAccountGetList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            console.log(jsonData)
            this.accountlist.items = jsonData;
            // let obj = {
            //   AC_USERNAME: "test",
            //   AC_CONTENT: "test",
            //   AC_TITLE: "test",
            //   AC_USERID: "test",
            //   AC_TEL: "test",
            //   AC_GROUP_ID: null,
            //   AC_STATUS: 0,
            //   AC_ID: null,
            // }
            // this.accountlist.items.push(obj)
            this.accountlist.items.sort((a, b)=> {
              return a.AC_STATUS - b.AC_STATUS
            })
            this.FunctionToken(this.getAccountGroupGetList, {});
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getAccountGroupGetList(data) {
      this.apiAccountGroupGetList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          // this.imageObj = json.Data
          this.grouplist = JSON.parse(json.Data);
          this.itemsmapping();
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    updateAccountAdmin(data) {
      this.apiUpdateAccountAdmin(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("帳號已更新成功");
            this.$router.go();
          } else {
            alert("帳號更新失敗");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    insertAccountAdmin(data) {
      this.apiInsertAccountAdmin(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            // let jsonData = JSON.parse(json.Data);
            // let obj={
            //     AC_USERNAME: jsonData.AC_USERNAME,
            //     AC_CONTENT: jsonData.AC_CONTENT,
            //     AC_TITLE: jsonData.AC_TITLE,
            //     AC_USERID: jsonData.AC_USERID,
            //     AC_TEL: jsonData.AC_TEL,
            //     AC_GROUP_ID: jsonData.AC_GROUP_ID,
            //     AC_STATUS: jsonData.AC_STATUS,
            //     AC_ID: jsonData.AC_ID
            // }
            alert("新增帳號成功");
            this.$router.go();
            // this.accountlist.items.push(JSON.parse(JSON.stringify(obj)))
          } else {
            alert("新增帳號失敗");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    deleteAccountAdmin(data) {
      this.apiDeleteAccountAdmin(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("帳號已成功移除");
            this.$router.go();
            // this.removeAccount(jsonData.AC_ID)
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    //END//
    updateAccount() {
      for (let i in this.accountlist.items) {
        let item = this.accountlist.items[i];
        if (item.AC_ID == this.accountlist.newaccount.AC_ID) {
          this.accountlist.items[i] = JSON.parse(
            JSON.stringify(this.accountlist.newaccount)
          );
          this.$router.go();
        }
      }
    },
    hideAccount(item) {
      return this.hidelist.indexOf(item.AC_USERID) == -1 ? true : false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    settotalRows() {
      this.totalRows = this.accountlist.mappingitems.length;
    },
    addaccount() {
      this.addAccount = true;
      this.resetAddAccountModal();
      this.$refs["accountinfomodal"].show();
    },
    removeAccount(id) {
      for (let i in this.accountlist.items) {
        let item = this.accountlist.items[i];
        if (item.AC_ID == id) {
          this.accountlist.items.splice(i, 1);
        }
      }
      for (let j in this.accountlist.mappingitems) {
        let item = this.accountlist.mappingitems[j];
        if (item.AC_ID == id) {
          this.accountlist.mappingitems.splice(j, 1);
        }
      }
    },
    deleteaccount(item) {
      this.accountlist.newaccount = this.finditem(item);
      this.$refs["deleteaccountmodal"].show();
    },
    handleAccountDelete() {
      this.FunctionToken(this.deleteAccountAdmin, {
        AC_ID: this.accountlist.newaccount.AC_ID,
      });
    },
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000001", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        this.FunctionToken(this.getAccountList, {});
      }
    },
    editaccount(item) {
      this.addAccount = false;
      this.accountlist.newaccount = this.finditem(item);
      this.$bvModal.show("modal-1");
    },
    finditem(item) {
      for (let i in this.accountlist.items) {
        let value = this.accountlist.items[i];
        if (value.AC_ID == item.AC_ID && value.AC_EMAIL == item.AC_EMAIL) {
          return JSON.parse(JSON.stringify(value));
        }
      }
    },
    resetAddAccountModal() {
      this.accountlist.newaccount.AC_USERNAME = null;
      this.accountlist.newaccount.AC_CONTENT = null;
      this.accountlist.newaccount.AC_TITLE = null;
      this.accountlist.newaccount.AC_USERID = null;
      this.accountlist.newaccount.AC_TEL = null;
      this.accountlist.newaccount.AC_GROUP_ID = null;
      this.accountlist.newaccount.AC_STATUS = null;
      this.accountlist.newaccount.AC_ID = null;
    },
    handleAddAccountOk() {
      if (
        this.IsNull(this.accountlist.newaccount.AC_USERNAME) == "" ||
        this.IsNull(this.accountlist.newaccount.AC_USERID) == "" ||
        this.IsNull(this.accountlist.newaccount.AC_GROUP_ID) == "" ||
        isNaN(this.accountlist.newaccount.AC_STATUS) == "true"
      ) {
        this.resetAddAccountModal();
        alert("資料輸入不完全");
      } else if (this.accountlist.newaccount.AC_ID == null) {
        this.accountlist.newaccount.AC_STATUS = parseInt(
          this.accountlist.newaccount.AC_STATUS
        );
        this.FunctionToken(
          this.insertAccountAdmin,
          this.accountlist.newaccount
        );
      } else if (this.accountlist.newaccount.AC_ID != null) {
        this.accountlist.newaccount.AC_STATUS = parseInt(
          this.accountlist.newaccount.AC_STATUS
        );
        this.FunctionToken(
          this.updateAccountAdmin,
          this.accountlist.newaccount
        );
        //this.$forceUpdate()
      }
    },
    groupName(code, format) {
      var text = "-";
      if (format == "none") text = "";
      if (!code || code != "") {
        if (this.grouplist[code]) {
          return this.grouplist[code];
        } else {
          return text;
        }
      } else {
        return text;
      }
    },
    statusName(code, format) {
      var text = "-";
      if (format == "none") text = "";
      if (!code || code != "") {
        if (this.statuslist[code]) {
          return this.statuslist[code];
        } else {
          return text;
        }
      } else {
        return text;
      }
    },
    parseToOptions(options) {
      let list = [];
      for (let i in options) {
        let item = options[i];
        let obj = {
          text: item,
          value: i.toString(),
        };
        list.push(obj);
      }
      return list;
    },
    itemsmapping() {
      for (let i in this.accountlist.items) {
        let item = this.accountlist.items[i];
        let obj = JSON.parse(JSON.stringify(item));
        obj.AC_GROUP_ID = this.groupName(obj.AC_GROUP_ID);
        obj.AC_STATUS = this.statusName(obj.AC_STATUS);
        this.accountlist.mappingitems.push(obj);
      }
      this.settotalRows();
    },
    handleReSentEmailOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      // Hide the modal manually
      let item = {
        AC_USERID: this.accountlist.newaccount.AC_USERID,
      };
      this.FunctionToken(this.setForgetPasswordEmail, item);
      //alert("Email輸入成功")
    },
    waningPopUp(msg) {
      this.messageObject.warning.count = this.messageObject.dismissSecs;
      this.messageObject.warning.content = msg;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    warningCountChanged(count) {
      this.messageObject.warning.count = count;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
  },
};
</script>
